var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: _vm.isMobile } },
    [
      _c("cancel-load-dialog", {
        attrs: {
          "listing-human-id": _vm._.get(
            _vm.selectedLoad,
            "tacticalInfo.loadDetails.loadGroupHumanId",
            null
          ),
          "booked-load-id": _vm._.get(_vm.selectedLoad, "id", null),
          "load-id": _vm._.get(_vm.selectedLoad, "humanId", null)
        },
        on: { refresh: _vm.removeLoad },
        model: {
          value: _vm.showCancelModal,
          callback: function($$v) {
            _vm.showCancelModal = $$v
          },
          expression: "showCancelModal"
        }
      }),
      _vm._v(" "),
      _c(
        "v-master-detail-pane",
        {
          on: {
            reset: function($event) {
              return _vm.$confirm("reset the dispatch overview")
            }
          }
        },
        [
          _c(
            "v-layout",
            {
              staticClass: "pl-2",
              attrs: { slot: "master", column: "" },
              slot: "master"
            },
            [
              _c(
                "v-tabs",
                {
                  model: {
                    value: _vm.selectedTab,
                    callback: function($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab"
                  }
                },
                [
                  _c("v-tab", [_vm._v("\n          Map Loads\n        ")]),
                  _vm._v(" "),
                  _c("v-tab", [_vm._v("\n          Drivers\n        ")])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.selectedTab,
                    callback: function($$v) {
                      _vm.selectedTab = $$v
                    },
                    expression: "selectedTab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    [
                      _c("v-select-driver", {
                        attrs: {
                          company: _vm.company,
                          value: _vm.selectedDriverId
                        },
                        on: {
                          change: function($event) {
                            return _vm.driverFilterChange($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.selectedLoad
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-toolbar",
                                {
                                  attrs: {
                                    dense: "",
                                    dark: "",
                                    color: _vm.sidebarColor
                                  }
                                },
                                [
                                  _c(
                                    "v-toolbar-title",
                                    { attrs: { color: "" } },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.selectedLoad.humanId) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _vm.selectedBookedLoad
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            fab: "",
                                            flat: "",
                                            small: "",
                                            color: "white"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.cancelBookedLoad()
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("cancel")])],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isLoadGroup
                                ? [
                                    _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _vm.loadModel.customerName(
                                                  _vm.selectedLoad
                                                )
                                                  ? _c("v-list-tile-title", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.loadModel.customerName(
                                                              _vm.selectedLoad
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.loadModel.assignedTruckingCompanyDriverName(
                                                  _vm.selectedLoad
                                                )
                                                  ? _c(
                                                      "v-list-tile-sub-title",
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.loadModel.assignedTruckingCompanyDriverName(
                                                                _vm.selectedLoad
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("v-list-tile-sub-title", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("pluralize")(
                                                          _vm.selectedLoad
                                                            .loadGroup
                                                            .availableLoadCount,
                                                          "load",
                                                          {
                                                            includeNumber: true
                                                          }
                                                        )
                                                      ) +
                                                      " available\n                    "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c("v-list-tile-title", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "font-italic"
                                                    },
                                                    [_vm._v("Pickup: ")]
                                                  ),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          _vm.selectedLoad
                                                            .pickupTime
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider"),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(
                                                    "\n                      View Load\n                    "
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-action",
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      fab: "",
                                                      small: "",
                                                      color: "accent"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.viewLoad()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "chrome_reader_mode"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c("v-select-driver", {
                                              attrs: {
                                                company: _vm.company,
                                                value:
                                                  _vm.directDispatchDriverId,
                                                label: "Direct Assignment",
                                                loading: _vm.loadingBtn
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.directDispatch(
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedLoad.bookedLoads.length
                                      ? _c(
                                          "v-list",
                                          { attrs: { "three-line": "" } },
                                          [
                                            _c("v-subheader", [
                                              _vm._v(
                                                "\n                  Assignments\n                "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.selectedLoad.bookedLoads,
                                              function(bookedLoad) {
                                                return _c(
                                                  "v-booked-load-planner-list-tile",
                                                  {
                                                    key:
                                                      "booked_" +
                                                      bookedLoad.humanId,
                                                    attrs: {
                                                      "is-load-owner": false,
                                                      company: _vm.company,
                                                      load: bookedLoad
                                                    },
                                                    on: {
                                                      viewLoad: function(
                                                        $event
                                                      ) {
                                                        return _vm.selectBookedLoad(
                                                          bookedLoad
                                                        )
                                                      }
                                                    }
                                                  }
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ]
                                : _c(
                                    "v-list",
                                    { attrs: { "two-line": "" } },
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _vm.loadModel.customerName(
                                                _vm.selectedLoad
                                              )
                                                ? _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.loadModel.customerName(
                                                            _vm.selectedLoad
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.isLoadGroup
                                                ? _c(
                                                    "v-list-tile-sub-title",
                                                    [
                                                      _vm.loadModel.loadNickname(
                                                        _vm.selectedLoad
                                                      )
                                                        ? [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.loadModel.loadNickname(
                                                                    _vm.selectedLoad
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        : [
                                                            _c("b", [
                                                              _vm._v("From: ")
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.loadPickupRegion(
                                                                    _vm.selectedLoad
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _c("b", [
                                                              _vm._v("To: ")
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.loadDropoffRegion(
                                                                    _vm.selectedLoad
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.loadModel.assignedTruckingCompanyDriverName(
                                                _vm.selectedLoad
                                              )
                                                ? _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.loadModel.assignedTruckingCompanyDriverName(
                                                            _vm.selectedLoad
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "pluralize"
                                                      )(
                                                        _vm.hoursBetweenTimestamps(
                                                          _vm.selectedLoad
                                                            .pickupTime,
                                                          _vm.selectedLoad
                                                            .projectedDeliveryTime
                                                        ),
                                                        "hour",
                                                        { includeNumber: true }
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "font-italic"
                                                  },
                                                  [_vm._v("Pickup: ")]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        _vm.selectedLoad
                                                          .pickupTime
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-tile-sub-title", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "font-italic"
                                                  },
                                                  [_vm._v("Delivery: ")]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        _vm.selectedLoad
                                                          .projectedDeliveryTime
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider"),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                    View Load\n                  "
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    fab: "",
                                                    small: "",
                                                    color: "accent"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.viewLoad()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(_vm.viewLoadIcon)
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c("v-select-load-driver", {
                                            attrs: {
                                              load: _vm.selectedLoad,
                                              label: "Direct Assignment",
                                              company: _vm.company
                                            },
                                            on: {
                                              refresh: function($event) {
                                                return _vm.onDriverChange(
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedDriverId
                        ? [
                            _vm._.first(_vm.spaceTimeBookedLoads)
                              ? _c(
                                  "v-list",
                                  [
                                    _c("v-divider"),
                                    _vm._v(" "),
                                    _c("v-subheader", [
                                      _vm._v(_vm._s(_vm.selectedDriverName))
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.spaceTimeBookedLoads, function(
                                      load,
                                      idx
                                    ) {
                                      return [
                                        _c(
                                          "v-list-tile",
                                          {
                                            key:
                                              "driver_assigned_load_" +
                                              idx +
                                              "_" +
                                              load.humanId,
                                            class: [
                                              {
                                                "primary lighten-1": _vm.isSelectedLoad(
                                                  load
                                                )
                                              },
                                              _vm.loadStyleClass(load)
                                            ],
                                            attrs: {
                                              inactive: _vm.isSelectedLoad(
                                                load
                                              ),
                                              ripple: "",
                                              avatar: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.selectLoad(load)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c("v-list-tile-title", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.loadNickname(
                                                          load
                                                        ) ||
                                                          _vm._.get(
                                                            load,
                                                            "sponsor.name",
                                                            "..."
                                                          )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("v-list-tile-sub-title", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "font-italic"
                                                    },
                                                    [_vm._v("Pickup:")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          load.pickupTime
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("v-list-tile-sub-title", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "font-italic"
                                                    },
                                                    [_vm._v("Delivery:")]
                                                  ),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm._f("formatDate")(
                                                          load.projectedDeliveryTime
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-avatar",
                                              {
                                                attrs: {
                                                  color: _vm.spaceTimeBookedLoadGradient(
                                                    load
                                                  )
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "white"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(load.mapId))]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider", {
                                          key:
                                            "unassigned_divider_" +
                                            idx +
                                            "_" +
                                            load.humanId
                                        })
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _c(
                                  "v-list",
                                  [
                                    _c("v-divider"),
                                    _vm._v(" "),
                                    _c("v-subheader", [
                                      _vm._v("No Assignments.")
                                    ])
                                  ],
                                  1
                                )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-toolbar",
                        { staticClass: "pb-2", attrs: { extended: "" } },
                        [
                          _c("v-toolbar-title", [
                            _vm._v(
                              "\n              Direct Dispatching\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            {
                              attrs: { slot: "extension", column: "" },
                              slot: "extension"
                            },
                            [
                              _vm.accurateSince
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pa-0 ma-0 text-right align-center"
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "" } },
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              staticClass: "font-weight-light",
                                              attrs: { label: "", light: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.accurateSince) +
                                                  "\n                    "
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    fab: "",
                                                    small: "",
                                                    flat: "",
                                                    color: "accent"
                                                  },
                                                  on: {
                                                    click: _vm.loadDriverLoads
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("refresh")
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "pt-4",
                          class: { "side-list-desktop": !_vm.isMobile },
                          staticStyle: {
                            overflow: "auto",
                            "max-height": "500px"
                          },
                          attrs: { "pl-4": "", "min-height": "50vh" }
                        },
                        [
                          _vm.loadingDirectDispatchAssignments
                            ? _c(
                                "v-layout",
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-list",
                                { attrs: { "two-line": "", expand: "" } },
                                [
                                  _c(
                                    "v-list-group-subheader-activator",
                                    {
                                      attrs: {
                                        open: "",
                                        "subheader-text":
                                          "Awaiting Dispatch (" +
                                          _vm.driversAwaitingDispatch.length +
                                          ")",
                                        "toggle-open-icon": "visibility",
                                        "toggle-close-icon": "visibility_off"
                                      }
                                    },
                                    [
                                      _vm.driversAwaitingDispatch.length === 0
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "sentiment_very_satisfied"
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v("Great Work!")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-sub-title",
                                                    {
                                                      staticClass: "font-italic"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "nobody is waiting ..."
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.driversAwaitingDispatch,
                                        function(driver) {
                                          return [
                                            _c(
                                              "v-list-tile",
                                              {
                                                key:
                                                  "awaiting_dispatch_" +
                                                  driver.userId
                                              },
                                              [
                                                _c(
                                                  "v-list-tile-avatar",
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "yellow"
                                                        }
                                                      },
                                                      [_vm._v("warning")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile-content",
                                                  [
                                                    _c("v-list-tile-title", [
                                                      _vm._v(
                                                        _vm._s(driver.name)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-list-tile-avatar",
                                                  { attrs: { size: 25 } },
                                                  [
                                                    _c("bqa-certificate-icon", {
                                                      attrs: {
                                                        responsive: "",
                                                        driver: driver
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-group-subheader-activator",
                                    {
                                      attrs: {
                                        open: "",
                                        "subheader-text": "Assignments",
                                        "toggle-open-icon": "visibility",
                                        "toggle-close-icon": "visibility_off"
                                      }
                                    },
                                    [
                                      _vm.currentDriverAssignments.length === 0
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "sentiment_dissatisfied"
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "No current assignments"
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.currentDriverAssignments,
                                        function(assignment) {
                                          return [
                                            assignment.tacticalInfo
                                              ? _c(
                                                  "v-list-tile",
                                                  {
                                                    key:
                                                      "dispatch_assignment_driver_" +
                                                      assignment.tacticalInfo
                                                        .assignedTruckingCompanyDriverUserId,
                                                    class: _vm.loadStyleClass(
                                                      assignment
                                                    )
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-avatar",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.bookedLoadProgressIcon(
                                                                assignment
                                                              ).icon
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  assignment
                                                                    .tacticalInfo
                                                                    .assignedTruckingCompanyDriverName
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.loadPickupTime(
                                                                  assignment
                                                                )
                                                              ) +
                                                                ", " +
                                                                _vm._s(
                                                                  _vm.loadNickname(
                                                                    assignment
                                                                  ) ||
                                                                    assignment.humanId
                                                                )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.loadPickupRegion(
                                                                    assignment
                                                                  )
                                                                ) +
                                                                "\n                        to " +
                                                                _vm._s(
                                                                  _vm.loadDropoffRegion(
                                                                    assignment
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile-avatar",
                                                      { attrs: { size: 25 } },
                                                      [
                                                        _c(
                                                          "bqa-certificate-icon",
                                                          {
                                                            attrs: {
                                                              responsive: "",
                                                              driver: _vm.bookedLoadDriverInfo(
                                                                assignment
                                                              )
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-group-subheader-activator",
                                    {
                                      attrs: {
                                        open: "",
                                        "subheader-text": "Next Loads",
                                        "toggle-open-icon": "visibility",
                                        "toggle-close-icon": "visibility_off"
                                      }
                                    },
                                    [
                                      _vm._l(
                                        _vm.nextDriverAssignments,
                                        function(assignment, idx) {
                                          return [
                                            assignment.loads.length === 1
                                              ? [
                                                  _c(
                                                    "v-list-tile",
                                                    {
                                                      key:
                                                        "dispatch_next_assignment_driver_" +
                                                        idx,
                                                      class: _vm.loadStyleClass(
                                                        assignment.loads[0]
                                                      )
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-avatar",
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.bookedLoadProgressIcon(
                                                                  assignment
                                                                    .loads[0]
                                                                ).icon
                                                              )
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-content",
                                                        [
                                                          _c(
                                                            "v-list-tile-title",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  assignment.name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-tile-sub-title",
                                                            [
                                                              _vm._v(
                                                                "{\n                          {loadPickupTime(assignment.loads[0])}}, " +
                                                                  _vm._s(
                                                                    _vm.loadNickname(
                                                                      assignment
                                                                        .loads[0]
                                                                    ) ||
                                                                      assignment
                                                                        .loads[0]
                                                                        .humanId
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-tile-sub-title",
                                                            [
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    _vm.loadPickupRegion(
                                                                      assignment
                                                                        .loads[0]
                                                                    )
                                                                  ) +
                                                                  "\n                          to " +
                                                                  _vm._s(
                                                                    _vm.loadDropoffRegion(
                                                                      assignment
                                                                        .loads[0]
                                                                    )
                                                                  ) +
                                                                  "\n                        "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-avatar",
                                                        { attrs: { size: 25 } },
                                                        [
                                                          _c(
                                                            "bqa-certificate-icon",
                                                            {
                                                              attrs: {
                                                                responsive: "",
                                                                driver: _vm.bookedLoadDriverInfo(
                                                                  assignment
                                                                    .loads[0]
                                                                )
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            assignment.loads.length > 1
                                              ? [
                                                  _c(
                                                    "v-list-group",
                                                    {
                                                      key:
                                                        "dispatch_next_assignment_driver_group_" +
                                                        idx
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile",
                                                        {
                                                          attrs: {
                                                            slot: "activator"
                                                          },
                                                          slot: "activator"
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-tile-avatar",
                                                            {
                                                              attrs: {
                                                                size: 20
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-chip",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "primary"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "font-weight-bold white--text"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            assignment
                                                                              .loads
                                                                              .length
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-tile-content",
                                                            [
                                                              _c(
                                                                "v-list-tile-title",
                                                                [
                                                                  _c(
                                                                    "v-list-tile-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          assignment.name
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-list-tile-sub-title",
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            assignment
                                                                              .loads
                                                                              .length
                                                                          ) +
                                                                          " loads\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-list-tile-avatar",
                                                            {
                                                              attrs: {
                                                                size: 25
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "bqa-certificate-icon",
                                                                {
                                                                  attrs: {
                                                                    responsive:
                                                                      "",
                                                                    driver: _vm.bookedLoadDriverInfo(
                                                                      assignment
                                                                        .loads[0]
                                                                    )
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        assignment.loads,
                                                        function(load, lidx) {
                                                          return _c(
                                                            "v-list-tile",
                                                            {
                                                              key:
                                                                "dispatch_next_assignment_driver_group_" +
                                                                idx +
                                                                "_" +
                                                                lidx,
                                                              staticClass:
                                                                "pl-1",
                                                              class: _vm.loadStyleClass(
                                                                load
                                                              )
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-tile-avatar",
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.bookedLoadProgressIcon(
                                                                          load
                                                                        ).icon
                                                                      )
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list-tile-content",
                                                                [
                                                                  _c(
                                                                    "v-list-tile-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.loadDescription(
                                                                            load
                                                                          )
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-list-tile-sub-title",
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.loadPickupTime(
                                                                              load
                                                                            )
                                                                          ) +
                                                                          ", " +
                                                                          _vm._s(
                                                                            _vm.loadNickname(
                                                                              load
                                                                            ) ||
                                                                              load.humanId
                                                                          ) +
                                                                          "\n                          "
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-list-tile-sub-title",
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.loadPickupRegion(
                                                                              load
                                                                            )
                                                                          ) +
                                                                          "\n                            to " +
                                                                          _vm._s(
                                                                            _vm.loadDropoffRegion(
                                                                              load
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-group-subheader-activator",
                                    {
                                      attrs: {
                                        open: "",
                                        "subheader-text":
                                          "Unavailable (" +
                                          _vm.driversUnavailable.length +
                                          ")",
                                        "toggle-open-icon": "visibility",
                                        "toggle-close-icon": "visibility_off"
                                      }
                                    },
                                    [
                                      _vm.driversUnavailable.length == 0
                                        ? _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-avatar",
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "sentiment_satisfied_alt"
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "Everybody is Available!"
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(_vm.driversUnavailable, function(
                                        driver
                                      ) {
                                        return [
                                          _c(
                                            "v-list-tile",
                                            {
                                              key:
                                                "dispatch_unavailable_" +
                                                driver.userId
                                            },
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(_vm._s(driver.userName))
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-avatar",
                                                { attrs: { size: 25 } },
                                                [
                                                  _c("bqa-certificate-icon", {
                                                    attrs: {
                                                      responsive: "",
                                                      driver: driver
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "detail" },
            [
              _c("v-space-time-continuum", {
                attrs: {
                  "stc-booked-loads": _vm.spaceTimeBookedLoads,
                  "stc-planned-loads": _vm.spaceTimePlannedLoads
                },
                on: {
                  selectBookedLoad: function($event) {
                    return _vm.selectBookedLoad($event)
                  },
                  selectPlannedLoad: function($event) {
                    return _vm.selectPlannedLoad($event)
                  },
                  colorUpdate: function($event) {
                    return _vm.updateSidebarColor($event)
                  }
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43bb324b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bb324b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/components/DirectDispatchOverview.vue
// module id = null
// module chunks = 